import { Context, component } from "picoapp";
import A11yDialog from "a11y-dialog";

export const dialog = component((node: HTMLElement, context: Context) => {
  if (node.dataset.portal) {
    const portal = document.getElementById(node.dataset.portal);
    if (!portal) {
      console.error(
        `Portal ${node.dataset.portal} could not be found to instantiate dialog in.`,
        node
      );
      return;
    }

    const existingDialog = portal.querySelector(`#${node.id}`);
    if (!existingDialog) {
      portal.appendChild(node);
    } else {
      node.remove();
      return;
    }
  }
  const dialog = new A11yDialog(node);
  const state = context.getState();
  context.hydrate({
    ...state,
    dialogs: {
      ...state.dialogs,
      [node.id]: dialog,
    },
  });

  dialog.on("show", () => {
    document.documentElement.style.overflow = "hidden";
    window.igEvents = window.igEvents || [];
    window.igEvents.push({
      event: "dialog:show",
      properties: {
        dialogId: node.id,
      },
    });
  });

  dialog.on("hide", () => {
    document.documentElement.style.overflow = "";
    window.igEvents = window.igEvents || [];
    window.igEvents.push({
      event: "dialog:hide",
      properties: {
        dialogId: node.id,
      },
    });
  });

  return () => {
    if (dialog) {
      dialog.destroy();
    }
  };
});
